import fullLightLogo from "../../assets/white-logo.png";
import fullDarkLogo from "../../assets/black-logo.png";
import logo_2 from "../../assets/logo_2.png";
import logo_2_withname from "../../assets/logo_2_withname.png";

export default function FooterSection({ content }) {
  return (
    <footer className="bg-gray-50 dark:bg-gray-800 py-10">
      <div className="container mx-auto px-6 sm:px-12">
        {/* Top Logo & Message Section */}
        <div className="flex flex-col sm:flex-row items-center justify-between gap-6">
          {/* Logo and Title */}
          <div className="flex items-center space-x-4">
            <img src={logo_2} className="h-10" alt="Foodoscope Logo" />
            <span className="text-xl font-semibold text-gray-900 dark:text-white">
              <span style={{ color: "#04c389" }}>Foodo</span>
              <span
                className="dark:text-[#d9d9d9]"
                style={{ color: "#313131" }}
              >
                scope
              </span>
              <span style={{ color: "#04c389" }}>.</span>
            </span>
          </div>

          {/* Footer Message */}
          {/* <p className="text-sm text-gray-600 dark:text-gray-300 text-center sm:text-left max-w-md">
            {content.footer.message}
          </p> */}
        </div>

        {/* Divider */}
        <div className="border-t border-gray-200 dark:border-gray-700 my-8"></div>

        {/* Footer Columns */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 text-center sm:text-left text-gray-600 dark:text-gray-300">
          {/* About Us */}
          <div>
            <h3 className="font-semibold text-lg text-gray-900 dark:text-white mb-2">About Us</h3>
            <p className="text-sm">
              We are a passionate team committed to bringing the best food discovery experience. Join us and explore amazing dishes and recipes.
            </p>
          </div>

          {/* Social Links */}
          <div className="mx-auto w-fit">
            <h3 className="font-semibold text-lg text-gray-900 dark:text-white mb-2">Follow Us</h3>
            <div className="flex justify-center sm:justify-start space-x-6">
              <a href="#twitter" target="_blank" rel="noopener noreferrer" className="hover:text-green-500 transition-colors">
                <i className="fab fa-twitter fa-lg"></i>
              </a>
              <a href="https://linkedin.com/company/foodoscope" target="_blank" rel="noopener noreferrer" className="hover:text-green-500 transition-colors">
                <i className="fab fa-linkedin fa-lg"></i>
              </a>
              <a href="https://www.instagram.com/foodoscope_api/" target="_blank" rel="noopener noreferrer" className="hover:text-green-500 transition-colors">
                <i className="fab fa-instagram fa-lg"></i>
              </a>
            </div>
          </div>

          {/* Contact Us */}
          <div>
            <h3 className="font-semibold text-lg text-gray-900 dark:text-white mb-2">Contact Us</h3>
            <p className="text-sm">Email ID:</p>
            <p className="text-sm">
              <a href="mailto:ganesh.bagler+foodoscope@gmail.com" className="text-blue-500 hover:underline">
                ganesh.bagler+foodoscope@gmail.com
              </a>
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-semibold text-lg text-gray-900 dark:text-white mb-2">Quick Links</h3>
            <ul className="text-sm space-y-1">
              <li><a href="https://cosylab.iiitd.edu.in/" className="hover:text-green-500 transition-colors">CoSyLab</a></li>
              {/* <li><a href="#terms" className="hover:text-green-500 transition-colors">Terms of Service</a></li>
              <li><a href="#privacy" className="hover:text-green-500 transition-colors">Privacy Policy</a></li>
              <li><a href="#contact" className="hover:text-green-500 transition-colors">Contact</a></li> */}
            </ul>
          </div>
        </div>

        {/* Footer Bottom */}
        <div className="mt-10 text-center text-sm text-gray-600 dark:text-gray-300">
          <p>© 2025 Foodoscope Technologies Pvt. Ltd.</p>
        </div>
      </div>
    </footer>
  );
}
